
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { commonActions } from 'srcReact/components'
import { connect } from 'react-redux'

class ErrorPageOwner extends Component {

    componentDidMount() {
        this.props.getManagePaymentUrl(this.props.current_organization.info.id)
    }

    render() {
        const { t, managePaymentURL } = this.props 
        return (
            <div className="billing-error-page">
                <h2 className='billing-error-page__content-title'>{t('billing.errorPages.ownerPage.title')}</h2>
                <p className='billing-error-page__content-text'>{t('billing.errorPages.ownerPage.text')}</p>
                <div className="billing-error-page__content-button">
                    <a href={managePaymentURL && managePaymentURL.hosted_page.url} className="button is-primary">{t('billing.errorPages.ownerPage.cta')}</a>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { common, organization } = state;
    const { managePaymentURL } = common;
    const { current_organization } = organization;
    return { current_organization, managePaymentURL}
}

const actionCreators = {
    getManagePaymentUrl: commonActions.getManagePaymentUrl
}

const ExtendedComponent = withTranslation('common')(ErrorPageOwner);
const connectedSettingsOrganizationPageContainer = connect(mapStateToProps,actionCreators)(ExtendedComponent);
export { connectedSettingsOrganizationPageContainer as ErrorPageOwner };